<template>
  <div id="app">
    <div id="nav">
      <a
        class="head-handler-btn back-btn"
        href="javascript:;"
        v-if="homeType"
        @click="back"
      >
        <img src="./assets/img/common_img/back.png" alt />
      </a>
      <span class="title-nama">研大医学考研</span>
      <!-- <a
        class="head-handler-btn menu-btn"
        href="javascript:;"
        @click="menuToggle"
      >
        <img src="./assets/img/common_img/menu.png" alt />
      </a> -->
      <div class="menu-box" v-show="showMenu">
        <ul class="menu-ul">
          <li
            class="menu-li"
            v-for="item in navList"
            :key="item.name"
            @click="menuToggle"
          >
            <router-link :to="item.hookUrl" class="menu-link">
              <img class="nav-img" alt :src="item.url" />
              <span class="nav-name">{{ item.name }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- <router-link to="/">Home</router-link>|
    <router-link to="/about">About</router-link>-->
    <router-view />
    <div id="bottom">
      <div class="bottom-left">
        <a href="tel:4006600397">400-6600-397</a>
      </div>
      <div class="bottom-right">
        <a class="service-btn">在线咨询</a>
      </div>
    </div>

    <!-- 2022 01 13 注释美洽 添加贴图 -->
    <img :src="posImg.thr" @click="openMei" class="posImg" alt="图片" />
    <img
      :src="posImg.two"
      @click="openMei"
      class="posImg posImgTwo"
      alt="图片"
    />
    <img
      :src="posImg.one"
      @click="openMei"
      class="posImg posImgThr"
      alt="图片"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMenu: false,
      navList: [
        {
          name: "首页",
          url: require("./assets/img/common_img/nav1.png"),
          hookUrl: { name: "home" },
        },
        {
          name: "暑期试学",
          url: require("./assets/img/common_img/nav4.png"),
          hookUrl: { name: "shuqi" },
        },
        // {
        //   name: "春季试学",
        //   url: require("./assets/img/common_img/nav4.png"),
        //   hookUrl: { name: "chunji" }
        // },
        {
          name: "定向直录营",
          url: require("./assets/img/common_img/nav2.png"),
          hookUrl: { name: "dingxiang" },
        },
        {
          name: "西综诊断营",
          url: require("./assets/img/common_img/nav3.png"),
          hookUrl: { name: "fourday" },
        },
        // {
        //   name: "百天冲刺",
        //   url: require("./assets/img/common_img/nav4.png"),
        //   hookUrl: { name: "chongci" }
        // },
        {
          name: "中医直录营",
          url: require("./assets/img/common_img/nav5.png"),

          hookUrl: { name: "zhongyi" },
        },
        {
          name: "集训名师团",
          url: require("./assets/img/common_img/nav6.png"),
          hookUrl: { name: "mingshi" },
        },
        {
          name: "成功学员",
          url: require("./assets/img/common_img/nav7.png"),
          hookUrl: { name: "xueyuan" },
        },
        {
          name: "往期开营",
          url: require("./assets/img/common_img/nav8.png"),
          hookUrl: { name: "kaiying" },
        },
        {
          name: "集训基地",
          url: require("./assets/img/common_img/nav9.png"),
          hookUrl: { name: "jidi" },
        },
      ],
      posImg: {
        one:
          "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/one.png",
        two:
          "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/two.png",
        thr:
          "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/thr.png",
      },
      homeType: true,
    };
  },
  // 监听路由
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log(oldVal);
        if (val.path === "/") {
          this.homeType = false;
          this.openMei();
        } else {
          this.homeType = true;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    this.openMei();
    if (this.$route.path === "/") {
      this.homeType = false;
    } else {
      this.homeType = true;
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    menuToggle() {
      this.showMenu = !this.showMenu;
    },
    openMei() {
      _MEIQIA("showPanel");
    },
  },
};
</script>

<style lang="less" scoped>
#nav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  position: fixed;
  top: 0;
  background-color: #fff;
  z-index: 10000;
  border-bottom: 1px solid #999;

  .title-nama {
    font-weight: bold;
  }

  .head-handler-btn {
    display: block;
    width: 48px;
    height: 48px;
    line-height: 48px;
    position: absolute;
    top: 6px;

    &.back-btn {
      left: 6px;
    }

    &.menu-btn {
      right: 6px;
    }

    img {
      width: 50%;
      height: auto;
      vertical-align: middle;
      margin: 0;
    }
  }

  .menu-box {
    background-color: #fff;

    .menu-ul {
      margin: 0 auto;
      width: 90%;
      list-style: none;

      .menu-li {
        text-align: left;

        .menu-link {
          display: block;
          height: 50px;
          line-height: 50px;

          .nav-img {
            vertical-align: middle;
            width: 30px;
            height: 30px;
            margin: 0;
          }

          .nav-name {
            vertical-align: middle;
            color: #333;
            font-size: 16px;
            margin-left: 20px;
          }
        }

        &:not(:last-child) {
          border-bottom: 1px solid #999;
        }
      }
    }
  }
}

#bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  z-index: 10000;

  & > div {
    width: 50%;
    height: 40px;
    line-height: 40px;

    &.bottom-left {
      background-color: #822de3;

      a {
        color: #fff;
      }
    }

    &.bottom-right {
      background-color: #f6d229;

      a {
        color: #333;
      }
    }
  }
}

.posImg {
  width: 76.5px;
  height: 40px;
  position: fixed;
  right: 0;
  bottom: 90px;
}
.posImgTwo {
  bottom: 140px;
}
.posImgThr {
  bottom: 190px;
}
</style>
<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  color: #333;
  font-size: 14px;
  padding: 60px 0;

  img {
    // margin-top: -1px;
  }
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: #333;
}
</style>
